/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
// import { useStaticQuery, graphql } from "gatsby"
// import { Container, Row, Col } from "reactstrap"
import Helmet from "react-helmet";
import SEO from "./seo";

import "typeface-roboto";
import "../assets/sass/main.scss";

const Layout = ({ children }) => {
  return (
    <>
      <SEO title="The all-in-one payment platform for SMEs and entrepreneurs" />
      <Helmet></Helmet>
      <div id="page-wrapper">
        <div>{children}</div>
      </div>
    </>
  );
};

// touch

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
